import { render, staticRenderFns } from "./CreatePayroll.vue?vue&type=template&id=3319a785"
import script from "./CreatePayroll.vue?vue&type=script&lang=js"
export * from "./CreatePayroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports